import { render, staticRenderFns } from "./GoodsclassBody.vue?vue&type=template&id=30437c57&scoped=true"
import script from "./GoodsclassBody.vue?vue&type=script&lang=js"
export * from "./GoodsclassBody.vue?vue&type=script&lang=js"
import style0 from "./GoodsclassBody.vue?vue&type=style&index=0&id=30437c57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30437c57",
  null
  
)

export default component.exports